<template>
  <div class="container_wrap" style="padding-bottom: 0px;">
    <div class="container_swiper layout">
      <div class="swiper_list">

        <van-swipe class="my-swipe" :autoplay="2000" indicator-color="white">
          <van-swipe-item><a href="https://org.ttcdw.cn/project/983123849693712384" title="山西省第三届家庭教育指导技能大赛报名及赛事安排"
              target="_blank"><img
                src="https://rms.guorent.com/dev/upload/article/17FB812870B73B60B532DEE645E5BE5E/1746585754.jpg"></a></van-swipe-item>
          <van-swipe-item><a href="https://org.ttcdw.cn/project/1008524418735845376" title="2025年山西省家庭教育指导专业能力提升培训"
              target="_blank"><img
                src="https://rms.guorent.com/dev/upload/article/225A5ECEE604E1228A2C38E432873AE4/1752642900.png"></a></van-swipe-item>

        </van-swipe>
      </div>
      <div id="news">
        <div class="news_two">
          <div class="layout_head has_theme color_1577FE">
            <div class="head_p_list">
              <p :class="['head_p', current==4?'active':'']" @click="handleClick(4)">大赛通知</p>
              <p :class="['head_p', current==5?'active':'']" @click="handleClick(5)">培训动态</p>
            </div>
            <div class="head_a_list">
              <a style="display: block;" class="head_a has_theme hover_theme  color_1577FE color_1577FE_hover"
                @click="toPage('/networking/skillslist/'+current)">更多+</a>
            </div>
          </div>
          <div class=" main_body news_is_show">
            <ul class="list hover_theme color_1577FE_hover" style="margin-bottom:px;">
              <li class="item has_theme color_1577FE">
                <a class="hover_theme color_1577FE_hover" href="/h/spec/sxjtjy/zxdt/2025-05-07/49551.html"
                  title="山西省第三届家庭教育指导技能大赛报名及赛事安排" target="_blank">山西省第三届家庭教育指导技能大赛报名及赛事安排</a>
                <span>05-07</span>
              </li>
              <li class="item has_theme color_1577FE">
                <a class="hover_theme color_1577FE_hover" href="/h/spec/sxjtjy/zxdt/2024-10-14/35875.html"
                  title="山西省第二届家庭教育指导技能大赛报名及赛事安排" target="_blank">山西省第二届家庭教育指导技能大赛报名及赛事安排</a>
                <span>10-14</span>
              </li>

            </ul>
            <ul class="list hover_theme color_1577FE_hover" style="margin-bottom:;display: none;">
              <li class="item has_theme color_1577FE">
                <a class="hover_theme color_1577FE_hover" href="https://org.ttcdw.cn/project/1008529379621535744"
                  title="2025年山西省校园心理健康指导专业能力提升培训" target="_blank">2025年山西省校园心理健康指导专业能力提升培训</a>
                <span>07-16</span>
              </li>
              <li class="item has_theme color_1577FE">
                <a class="hover_theme color_1577FE_hover" href="https://org.ttcdw.cn/project/1008524418735845376"
                  title="2025年山西省家庭教育指导专业能力提升培训" target="_blank">2025年山西省家庭教育指导专业能力提升培训</a>
                <span>07-16</span>
              </li>
              <li class="item has_theme color_1577FE">
                <a class="hover_theme color_1577FE_hover" href="https://org.ttcdw.cn/project/906688774909009920"
                  title="2024年家庭教育指导专项能力证书培训" target="_blank">2024年家庭教育指导专项能力证书培训</a>
                <span>12-02</span>
              </li>
              <li class="item has_theme color_1577FE">
                <a class="hover_theme color_1577FE_hover" href="https://org.ttcdw.cn/project/901301628724568064"
                  title="2024年家庭教育指导专业能力提升培训" target="_blank">2024年家庭教育指导专业能力提升培训</a>
                <span>12-02</span>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="main" class="layout_main layout">


      <!--单行-->
      <headTitle :dynamicTitle="'大赛相关'" :jumpPath="'/networking/skillscompetition/1'" class="card_one Multiline">
        <div class="list">
          <div class="item" @click="toPage('/networkingsingup/index')">
            <a class="img" title="山西省第三届家庭教育指导技能大赛">
              <img src="https://rms.guorent.com/dev/upload/article/CB8DE6D881FF1FC1170A4426BF17C4FE/1746585909.jpg">
            </a>
            <div class="item_dl">
              <div style="display:block;" class="item_title">
                <a href="https://org.ttcdw.cn/project/983123849693712384" title="山西省第三届家庭教育指导技能大赛" target="_blank">
                  山西省第三届家庭教育指导技能大赛
                </a>
              </div>
              <div style="display:block;" class="item_detail">
              </div>

            </div>
          </div>
          <div class="item">
            <a class="img" title="山西省第二届家庭教育指导技能大赛">
              <img src="https://rms.guorent.com/dev/upload/article/19E57458313D0E730FD3BC5546B4960F/1728904120.png">
            </a>
            <div class="item_dl">
              <div style="display:block;" class="item_title">
                <a href="https://org.ttcdw.cn/project/903439760222658560" title="山西省第二届家庭教育指导技能大赛" target="_blank">
                  山西省第二届家庭教育指导技能大赛
                </a>
              </div>
              <div style="display:block;" class="item_detail">
              </div>

            </div>
          </div>
        </div>

      </headTitle>

      <!--精品课程 end-->
      <!--示范引领-->
      <headTitle :dynamicTitle="'直播课堂'" :jumpPath="'/networking/liveclass'" class="course_one  Multiline">
        <div class="list">
          <div class="item" @click="toPage('/course')">
            <a class="img" title="《中华人民共和国爱国主义教育法》解读">
              <img src="https://rms.guorent.com/dev/upload/article/3D2F146499A0ACF073F2FA2D9B9D2E62/17273344851.jpg">
            </a>
            <div class="item_dl">
              <a title="《中华人民共和国爱国主义教育法》解读" class="item_title hover_theme color_1577FE_hover">《中华人民共和国爱国主义教育法》解读</a>
              <p class="item_name">主讲人：姚荣</p>
              <div style="display:-webkit-box;" class="item_detail">2024-09-27 19:00-19:40</div>

            </div>
          </div>
          <div class="item">
            <a class="img" href="https://training.ttcdw.cn/training/site/v/56682387" title="专业技术，为家庭教育指导赋能"
              target="_blank">
              <img src="https://rms.guorent.com/dev/upload/article/1BF6203208FAD467DECC06779ED04C53/1727227345.png">
            </a>
            <div class="item_dl">
              <a href="https://training.ttcdw.cn/training/site/v/56682387" title="专业技术，为家庭教育指导赋能" target="_blank"
                class="item_title hover_theme color_1577FE_hover">专业技术，为家庭教育指导赋能</a>
              <p class="item_name">主讲人：付丽旻</p>
              <div style="display:-webkit-box;" class="item_detail">2024-09-24 19:00-21:00</div>

            </div>
          </div>
          <div class="item">
            <a class="img" href="https://www.ttcdw.cn/p/uc/studentCommand/889266650262642688"
              title="公益直播来啦！新学期起航：怎样让孩子爱上学习" target="_blank">
              <img src="https://rms.guorent.com/dev/upload/article/8D51A261D974412378B8AB1E35426994/1724314865.png">
            </a>
            <div class="item_dl">
              <a href="https://www.ttcdw.cn/p/uc/studentCommand/889266650262642688" title="公益直播来啦！新学期起航：怎样让孩子爱上学习"
                target="_blank" class="item_title hover_theme color_1577FE_hover">公益直播来啦！新学期起航：怎样让孩子爱上学习</a>
              <p class="item_name">主讲人：边玉芳</p>
              <div style="display:-webkit-box;" class="item_detail">2024-08-23 19:00-19:40</div>

            </div>
          </div>
          <div class="item">
            <a class="img" href="https://www.ttcdw.cn/p/uc/studentCommand/800908818391535616"
              title="家庭劳动教育与品德培养——让孩子在劳动中成长" target="_blank">
              <img src="https://rms.guorent.com/dev/upload/article/D21987F596C750D6278D398BC1BDB702/1703490736.jpg">
            </a>
            <div class="item_dl">
              <a href="https://www.ttcdw.cn/p/uc/studentCommand/800908818391535616" title="家庭劳动教育与品德培养——让孩子在劳动中成长"
                target="_blank" class="item_title hover_theme color_1577FE_hover">家庭劳动教育与品德培养——让孩子在劳动中成长</a>
              <p class="item_name">主讲人：戴君</p>
              <div style="display:-webkit-box;" class="item_detail">2023-12-30 19:00-19:40</div>

            </div>
          </div>
        </div>


      </headTitle>
      <headTitle :dynamicTitle="'专家团队'" :jumpPath="'/networking/expertteam'" class="panel_one   Multiline">

        <div class="list">
          <div class="item" @click="toPage('/networking/detail')">
            <div class="item_top">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35711.html" title="&nbsp;赵忠心" target="_blank">
                <img src="http://rms.guorent.com/dev/upload/article/779A6D92E45DD95DC8061C8DBFC6910A/1650972626.png">
              </a>
              <div class="item_top_dl">
                <div class="item_top_dt">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35711.html" title="&nbsp;赵忠心" target="_blank"> &nbsp;赵忠心</a>
                </div>
                <div class="item_top_dd">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35711.html" title="" target="_blank"></a>
                </div>
              </div>
            </div>
            <a class="item_detail hover_theme color_1577FE_hover" href="/h/spec/sxjtjy/sfyl/2024-10-14/35711.html"
              title="&nbsp;赵忠心" target="_blank">
              中国家庭教育研究第一人，北京师范大学教科所研究员 ，中国教育学会家庭教育专业委员会理事长，国家基础教育实验中心社区与家庭教育研究所所长。 </a>
          </div>
          <div class="item">
            <div class="item_top">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35719.html" title="苑宁宁" target="_blank">
                <img src="http://rms.guorent.com/dev/upload/article/02A1503546215D7B3F5965CE1CAAABA7/1650968514.png">
              </a>
              <div class="item_top_dl">
                <div class="item_top_dt">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35719.html" title="苑宁宁" target="_blank"> 苑宁宁</a>
                </div>
                <div class="item_top_dd">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35719.html" title="" target="_blank"></a>
                </div>
              </div>
            </div>
            <a class="item_detail hover_theme color_1577FE_hover" href="/h/spec/sxjtjy/sfyl/2024-10-14/35719.html"
              title="苑宁宁" target="_blank">
              家庭教育立法专家顾问，家庭教育促进法起草工作领导小组办公室成员，中国政法大学未成年人事务治理与法律研究基地副主任，中国政法大学副教授、法学博士，国务院妇女儿童工作委员会办公室专家智库成员。 </a>
          </div>
          <div class="item">
            <div class="item_top">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35723.html" title="孙云晓" target="_blank">
                <img src="http://rms.guorent.com/dev/upload/article/4C129D3CB512E4051BFE58BF4EF11DE2/1650972060.png">
              </a>
              <div class="item_top_dl">
                <div class="item_top_dt">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35723.html" title="孙云晓" target="_blank"> 孙云晓</a>
                </div>
                <div class="item_top_dd">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35723.html" title="" target="_blank"></a>
                </div>
              </div>
            </div>
            <a class="item_detail hover_theme color_1577FE_hover" href="/h/spec/sxjtjy/sfyl/2024-10-14/35723.html"
              title="孙云晓" target="_blank">
              中国青少年研究中心家庭教育首席专家，首都师范大学特聘教授，国务院妇儿工委儿童工作智库专家，中国教育学会家庭教育专业委员会常务副理事长。 </a>
          </div>
          <div class="item">
            <div class="item_top">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35726.html" title="付丽旻" target="_blank">
                <img src="http://rms.guorent.com/dev/upload/article/A1B51B05ECC6AFA1A3043A59236CB782/1650972113.png">
              </a>
              <div class="item_top_dl">
                <div class="item_top_dt">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35726.html" title="付丽旻" target="_blank"> 付丽旻</a>
                </div>
                <div class="item_top_dd">
                  <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35726.html" title="" target="_blank"></a>
                </div>
              </div>
            </div>
            <a class="item_detail hover_theme color_1577FE_hover" href="/h/spec/sxjtjy/sfyl/2024-10-14/35726.html"
              title="付丽旻" target="_blank">
              上海市德育特级教师，德育正高级教师，心理咨询师，上海市劳动模范。 </a>
          </div>
        </div>



      </headTitle>
      <!--示范引领 end-->
      <!--文字列表 模块一-->
      <headTitle title="政策文件" :dynamicTitle="'政策文件'" :jumpPath="'/networking/skillslist/6'" class="wzlb_one   Multiline">
        <div class="list">
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover" @click="toPage('/networking/detail')">
            <a title=" 《中华人民共和国家庭教育促进法》">

              <div class="item_title">《中华人民共和国家庭教育促进法》</div>
              <div class="item_time ">04-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35736.html" title="《关于进一步减轻义务教育阶段学生作业负担和校外培训负担的意见》" target="_blank">

              <div class="item_title">《关于进一步减轻义务教育阶段学生作业负担和校外培训负担的意见》</div>
              <div class="item_time ">04-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35737.html" title="《全国家庭教育指导大纲（修订）》" target="_blank">

              <div class="item_title">《全国家庭教育指导大纲（修订）》</div>
              <div class="item_time ">04-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35738.html" title="《中华人民共和国未成年人保护法》" target="_blank">

              <div class="item_title">《中华人民共和国未成年人保护法》</div>
              <div class="item_time ">04-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35739.html" title="《中华人民共和国民法典》 第五编 婚姻家庭" target="_blank">

              <div class="item_title">《中华人民共和国民法典》 第五编 婚姻家庭</div>
              <div class="item_time ">04-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35732.html" title="《山西省家庭教育促进条例》" target="_blank">

              <div class="item_title">《山西省家庭教育促进条例》</div>
              <div class="item_time ">05-25</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35733.html"
              title="教育部等十七部门关于印发《全面加强和改进新时代学生心理健康工作专项行动计划（2023—2025年）》的通知" target="_blank">

              <div class="item_title">教育部等十七部门关于印发《全面加强和改进新时代学生心理健康工作专项行动计划（2023—2025年）》的通知</div>
              <div class="item_time ">04-28</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35734.html" title="教育部等八部门关于印发《全国青少年学生读书行动实施方案》的通知" target="_blank">

              <div class="item_title">教育部等八部门关于印发《全国青少年学生读书行动实施方案》的通知</div>
              <div class="item_time ">03-28</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35740.html" title="《教育部关于加强家庭教育工作的指导意见》" target="_blank">

              <div class="item_title">《教育部关于加强家庭教育工作的指导意见》</div>
              <div class="item_time ">04-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35741.html" title="中宣部印发《关于促进全民阅读工作的意见》深入推进全民阅读" target="_blank">

              <div class="item_title">中宣部印发《关于促进全民阅读工作的意见》深入推进全民阅读</div>
              <div class="item_time ">10-25</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35742.html" title="教育部关于加强和改进新时代基础教育教研工作的意见" target="_blank">

              <div class="item_title">教育部关于加强和改进新时代基础教育教研工作的意见</div>
              <div class="item_time ">11-26</div>

            </a>
          </div>
          <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
            <a href="/h/spec/sxjtjy/wzlb/2024-10-14/35743.html" title="教育部 中央编办 财政部 人力资源社会保障部 关于加强幼儿园教师队伍建设的意见"
              target="_blank">

              <div class="item_title">教育部 中央编办 财政部 人力资源社会保障部 关于加强幼儿园教师队伍建设的意见</div>
              <div class="item_time ">11-09</div>

            </a>
          </div>


        </div>



      </headTitle>


    </div>
  </div>
</template>


<script>
import CountTo from 'vue-count-to'
import { getDashboard } from '@/api/exam/examRecord'
import { courseList } from '@/api/exam/course'
import { wexinShare } from '@/utils/weixinSDK'
import { isWeixin } from "@/utils/utils";
const logoUrl = require("@/assets/img/logo.jpg");
import Vue from 'vue'
import Swipe from 'vant/lib/swipe';
import 'vant/lib/swipe/style';
import SwipeItem from 'vant/lib/swipe-item';
import 'vant/lib/swipe-item/style';
Vue.use(Swipe);
Vue.use(SwipeItem);
import headTitle from './component/headTitle'
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      current: 4,
      banner_bg: require("@/assets/img/bg-img/bg2.jpg")
    }
  },
  components: {
    CountTo,
    headTitle
  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },

  methods: {
    handleClick(index) {
      this.current = index;
    },

    // toPage(pageName) {
    //   this.$router.push(pageName)
    // },
    getDashboard() {
      getDashboard().then(resp => {
        this.dashboardInfo = resp.data;
      });
    },
    // 加载课程列表
    getCourseList() {
      courseList(this.courseQuery).then(response => {
        this.courseList = response.rows;
      }).catch(() => {
      })
    },
    handleStartCourse(course) {
      // messageWarn(this, '功能正在开发中！')
      this.$router.push({ name: 'course-details', query: { courseId: course.id } })
    },
    toPage(page) {
      this.$router.push(page)
    },

  },

}
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 100%;
  min-width: 1200px;
  padding-bottom: 306px;
  overflow: hidden;

  .layout {
    width: 1200px;
    margin: 0 auto;
  }

  .container_swiper {
    height: 377px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    .swiper_list {
      width: 740px;
      height: 377px;
      overflow: hidden;
      position: relative;
      background-color: #ffffff;

      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }

    #news {
      position: relative;
      width: 430px;
      height: 377px;

      .news_two {
        width: 100%;
        height: 100%;

        .layout_head {
          cursor: pointer;
          height: 40px;
          border-bottom: 1px solid #dfdfdf;
          position: relative;



          .head_p_list {
            .head_p {
              color: #333;
              margin-right: 20px;
              // position: relative;
              float: left;
              line-height: 30px;
              font-size: 24px;
              font-weight: 500;


            }

          }

          .head_a_list {
            .head_a {
              float: right;
              margin-top: 16px;
              line-height: 14px;
              font-size: 14px;
              font-weight: bold;
            }
          }

          .color_1577FE {
            color: #1577fe;

            .head_p:before {
              background: #1577fe;
            }
          }

          .active {
            position: relative;
            color: #1577fe;

            &::before {
              content: "";
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 52px;
              height: 2px;

            }
          }
        }

        .color_1577FE {
          color: #1577fe;


          .head_p_list {

            .head_p:hover,
            .active {
              color: #1577fe;
            }

            .head_p::before {
              background: #1577fe;
            }

          }

        }

        .main_body {
          padding-top: 15px;
          overflow: hidden;
          position: relative;

          .list {
            .item {
              position: relative;
              width: 100%;
              padding-left: 17px;
              box-sizing: border-box;
              color: #505050;
              font-size: 18px;
              font-weight: 400;
              height: 36px;
              line-height: 36px;


              a {
                width: 80%;
                float: left;
                color: #505050;
                font-size: 18px;
                font-weight: 400;
                line-height: 36px;

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-all;

                &:hover {
                  color: #1577fe;
                }
              }

              span {
                float: right;
                color: #999;
                font-size: 14px;
                font-weight: 400;
                line-height: 36px;
                display: block;
              }
            }

            .color_1577FE:before {
              background-color: #1577fe;
            }
          }

          .item::before {
            content: "";
            position: absolute;
            top: 16px;
            left: 0;
            width: 4px;
            height: 4px;

          }
        }
      }
    }
  }

  #main {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 45px;

    .card_one,
    .course_one,
    .panel_one {
      width: 100%;

      .item {
        margin-bottom: 30px;
        width: 290px;
        margin-right: 13px;

        a {
          display: block;
          position: relative;
          width: 100%;


        }

        .img {
          width: 290px;
          height: 162px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item_dl {
          padding-top: 17px;

          .item_title a,
          .item_title {

            height: 24px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;

          }

          .item_name {
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
          }

          .item_detail {
            max-height: 72px;
            margin-top: 4px;
            line-height: 24px;
            font-size: 14px;
            font-weight: 400;
            color: #505050;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }

      }

      a {
        display: block;
        position: relative;
      }
    }

    .course_one {}

    .panel_one {
      .item_top {
        box-sizing: border-box;
        border-bottom: 2px solid #F1F2F5;
        margin-bottom: 1px;
        padding: 21px;
        padding-right: 0px;
        background-color: #f6f7fa;
        display: flex;
        flex-wrap: wrap;

        .img {
          width: 124px;
          height: 124px;
          padding: 5px;
          box-sizing: border-box;
          margin-right: 31px;
          border-radius: 50%;
          background-color: #E1E0E0;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .item_top_dl {
          width: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .item_top_dt {
            width: 100%;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            margin-bottom: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;

            a {
              width: 100px;
              font-size: 24px;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
            }
          }

          .item_top_dd {
            width: 100%;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;

            a {
              width: 100%;
              font-size: 18px;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
            }
          }
        }
      }

      .item_detail {
        padding: 16px 25px 0px;
        font-size: 14px;
        font-weight: 300;
        color: #505050;
        line-height: 24px;
        background-color: #f6f7fa;
        text-indent: 28px;
        height: 112px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
    }

    .wzlb_one {
      .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item {
          position: relative;
          width: 570px;
          box-sizing: border-box;
          color: #505050;
          font-size: 18px;
          font-weight: 400;
          height: 36px;
          line-height: 36px;

          .item_left {
            width: 100%;
            display: block;
            height: 36px;
            float: left;
            /*display: flex;*/
          }
        }

        .item_icon {
          float: left;
          width: 32px;
          height: 36px;
          line-height: 36px;

          .icon {
            font-size: 20px;
            width: 1em;
            height: 36px;
            vertical-align: -1px;
            fill: currentColor;
            overflow: hidden;
          }

          img {
            display: block;
          }
        }

        .item_title {
          float: left;
          color: #333333;
          font-size: 16px;
          font-weight: 400;
          line-height: 36px;
          width: 75%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
        }

        .item_name {
          float: right;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
          line-height: 36px;
          margin-left: 10px;
        }

        .item_download {
          float: right;
          color: #999;
          font-size: 14px;
          font-weight: 400;
          line-height: 36px;
          margin-left: 10px;
        }

        .item_time {
          float: right;
          color: #999;
          font-size: 14px;
          font-weight: 400;
          line-height: 36px;
          margin-left: 10px;
        }
      }

    }
  }
}
</style>
